import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrl: './page-not-found.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PageNotFoundComponent {
    constructor(private router: Router) { }

    public returnToLanding(): void {
        this.router.navigate(['/landing']).catch((error) => {
            console.error('PageNotFoundComponent: failed to navigate to /landing', error);
        });
    }
}